var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('singleDateForm',{attrs:{"label":_vm.$t('general.dueDate'),"data-cy":"dueDate","prependIcon":"event","rules":[]},model:{value:(_vm.value.dueDate),callback:function ($$v) {_vm.$set(_vm.value, "dueDate", $$v)},expression:"value.dueDate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }